import React from "react";
import { Card } from "reactstrap";
import { P } from "../../AbstractElements";
import { useTranslation } from "react-i18next";

export const UnderConstruction = () => {
  const { t } = useTranslation();

  return (
    <Card className="text-center" style={{ padding: "60px 40px" }}>
      <div style={{ fontSize: "80px", marginBottom: "30px" }}>🚧</div>

      <h2
        style={{
          fontSize: "28px",
          fontWeight: "600",
          marginBottom: "20px",
          color: "#333",
        }}
      >
        {t("PAGE_UNDER_CONSTRUCTION")}
      </h2>

      <P
        style={{
          fontSize: "16px",
          color: "#666",
          lineHeight: "1.6",
          marginBottom: "30px",
        }}
      >
        {t("CONSTRUCTION_MESSAGE")}
        <br />
        {t("CONSTRUCTION_SUBTITLE")}
      </P>

      <div style={{ fontSize: "24px", opacity: "0.7" }}>
        ⏳ {t("COMING_SOON")}
      </div>
    </Card>
  );
};
